var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrinchHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29393",
    "data-name": "Group 29393",
    transform: "translate(-288 -342.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(288 342.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-grinch",
    transform: "translate(305 349.768)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_443",
    "data-name": "Ellipse 443",
    cx: 4.959,
    cy: 4.437,
    rx: 4.959,
    ry: 4.437,
    transform: "translate(3.654 6.507)",
    fill: "#7cb342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50189",
    "data-name": "Path 50189",
    d: "M26.216,6.545s.2-2.712-.869-3.425c-1.3-.869-2.608-.279-3.477-.714C19.7,1.322,19.7,1,18.828,1,17.1,1,14.084,5.781,14.084,7.942l8.51-.042a15.486,15.486,0,0,0-1.159-3.911c2.608,0,3.932,2.655,3.932,2.655Z",
    transform: "translate(-9.701 -1)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50190",
    "data-name": "Path 50190",
    d: "M21.776,29.6c0,4.385-7.388,6.084-7.388,6.084S7,33.983,7,29.6c0-2.5,3.068-1.738,7.388-1.738S21.776,27.1,21.776,29.6Z",
    transform: "translate(-5.696 -16.125)",
    fill: "#7cb342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50191",
    "data-name": "Path 50191",
    d: "M33.491,26s2.608-.445,3.477,3.467c0,0-.393-.251-.874-.5a4.661,4.661,0,0,1,.438,2.236l-.945-.954a5.535,5.535,0,0,1-.17,1.822l-.623-1.027a1.726,1.726,0,0,1-.869,1.464v-1.3l-2.371.58Z",
    transform: "translate(-19.579 -15.128)",
    fill: "#7cb342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50192",
    "data-name": "Path 50192",
    d: "M7.476,26S4.869,25.559,4,29.47c0,0,.393-.251.874-.5a4.661,4.661,0,0,0-.438,2.236l.945-.954a5.548,5.548,0,0,0,.17,1.822l.623-1.02a1.717,1.717,0,0,0,.869,1.457v-1.3l2.371.58Z",
    transform: "translate(-3.999 -15.128)",
    fill: "#7cb342"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_444",
    "data-name": "Ellipse 444",
    cx: 2.61,
    cy: 2.61,
    rx: 2.61,
    ry: 2.61,
    transform: "translate(11.484 10.683)",
    fill: "#7cb342"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_445",
    "data-name": "Ellipse 445",
    cx: 2.349,
    cy: 2.61,
    rx: 2.349,
    ry: 2.61,
    transform: "translate(1.044 10.683)",
    fill: "#7cb342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50193",
    "data-name": "Path 50193",
    d: "M41.247,13.992a.52.52,0,0,0,.2-.6v0a.526.526,0,0,0-.533-.351.517.517,0,0,0-.238-.584.524.524,0,0,0-.634.073.527.527,0,0,0-1,.166.527.527,0,0,0-.62.136.52.52,0,0,0-.032.636.518.518,0,0,0-.389.5.524.524,0,0,0,.35.493.515.515,0,0,0,.035.6.527.527,0,0,0,.616.156.521.521,0,0,0,.424.476.5.5,0,0,0,.1.007.526.526,0,0,0,.47-.285.532.532,0,0,0,.63.094.526.526,0,0,0,.259-.581.525.525,0,0,0,.543-.334A.513.513,0,0,0,41.247,13.992Z",
    transform: "translate(-23.223 -7.347)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8462",
    "data-name": "Rectangle 8462",
    width: 9.344,
    height: 2.608,
    transform: "translate(4.129 5.867)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_446",
    "data-name": "Ellipse 446",
    cx: 0.783,
    cy: 0.522,
    rx: 0.783,
    ry: 0.522,
    transform: "translate(12.528 5.463)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_447",
    "data-name": "Ellipse 447",
    cx: 0.522,
    cy: 0.522,
    rx: 0.522,
    ry: 0.522,
    transform: "translate(11.484 5.463)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_448",
    "data-name": "Ellipse 448",
    cx: 0.783,
    cy: 0.522,
    rx: 0.783,
    ry: 0.522,
    transform: "translate(9.918 5.463)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_449",
    "data-name": "Ellipse 449",
    cx: 0.783,
    cy: 0.783,
    rx: 0.783,
    ry: 0.783,
    transform: "translate(12.528 6.507)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_450",
    "data-name": "Ellipse 450",
    cx: 0.652,
    cy: 0.652,
    rx: 0.652,
    ry: 0.652,
    transform: "translate(3.477 6.546)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_451",
    "data-name": "Ellipse 451",
    cx: 0.652,
    cy: 0.652,
    rx: 0.652,
    ry: 0.652,
    transform: "translate(3.477 5.242)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_452",
    "data-name": "Ellipse 452",
    cx: 0.652,
    cy: 0.652,
    rx: 0.652,
    ry: 0.652,
    transform: "translate(4.781 5.242)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_453",
    "data-name": "Ellipse 453",
    cx: 0.652,
    cy: 0.652,
    rx: 0.652,
    ry: 0.652,
    transform: "translate(6.085 5.242)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_454",
    "data-name": "Ellipse 454",
    cx: 0.652,
    cy: 0.652,
    rx: 0.652,
    ry: 0.652,
    transform: "translate(7.389 5.242)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_455",
    "data-name": "Ellipse 455",
    cx: 0.522,
    cy: 0.522,
    rx: 0.522,
    ry: 0.522,
    transform: "translate(8.874 5.463)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_456",
    "data-name": "Ellipse 456",
    cx: 0.652,
    cy: 0.652,
    rx: 0.652,
    ry: 0.652,
    transform: "translate(12.604 7.85)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_457",
    "data-name": "Ellipse 457",
    cx: 0.652,
    cy: 0.652,
    rx: 0.652,
    ry: 0.652,
    transform: "translate(11.3 7.85)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_458",
    "data-name": "Ellipse 458",
    cx: 0.652,
    cy: 0.652,
    rx: 0.652,
    ry: 0.652,
    transform: "translate(9.996 7.85)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_459",
    "data-name": "Ellipse 459",
    cx: 0.652,
    cy: 0.652,
    rx: 0.652,
    ry: 0.652,
    transform: "translate(3.477 7.85)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_460",
    "data-name": "Ellipse 460",
    cx: 0.652,
    cy: 0.652,
    rx: 0.652,
    ry: 0.652,
    transform: "translate(4.781 7.85)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_461",
    "data-name": "Ellipse 461",
    cx: 0.652,
    cy: 0.652,
    rx: 0.652,
    ry: 0.652,
    transform: "translate(6.085 7.85)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_462",
    "data-name": "Ellipse 462",
    cx: 0.652,
    cy: 0.652,
    rx: 0.652,
    ry: 0.652,
    transform: "translate(7.389 7.85)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_463",
    "data-name": "Ellipse 463",
    cx: 0.652,
    cy: 0.652,
    rx: 0.652,
    ry: 0.652,
    transform: "translate(8.692 7.85)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50194",
    "data-name": "Path 50194",
    d: "M27.606,7.383S25.433,7.871,25,7c0,0,.266,1.431,2.971,1.288C27.862,7.992,27.606,7.383,27.606,7.383Z",
    transform: "translate(-15.872 -4.394)",
    fill: "#b71c1c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_464",
    "data-name": "Ellipse 464",
    cx: 1.305,
    cy: 0.522,
    rx: 1.305,
    ry: 0.522,
    transform: "translate(7.308 13.293)",
    fill: "#0b420d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_465",
    "data-name": "Ellipse 465",
    cx: 1.305,
    cy: 1.305,
    rx: 1.305,
    ry: 1.305,
    transform: "translate(9.918 10.683)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_466",
    "data-name": "Ellipse 466",
    cx: 1.305,
    cy: 1.305,
    rx: 1.305,
    ry: 1.305,
    transform: "translate(4.698 10.683)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_467",
    "data-name": "Ellipse 467",
    cx: 0.522,
    cy: 0.522,
    rx: 0.522,
    ry: 0.522,
    transform: "translate(10.44 11.205)",
    fill: "#0b420d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_468",
    "data-name": "Ellipse 468",
    cx: 0.261,
    cy: 0.522,
    rx: 0.261,
    ry: 0.522,
    transform: "translate(6.264 11.205)",
    fill: "#0b420d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50195",
    "data-name": "Path 50195",
    d: "M27.911,24.448c-1.981,0-2.173,2.173-3.042,2.173-.7,0-.869-.869-.869-.869a.6.6,0,0,0,.869,0c.326-.326.9-1.524,1.594-1.678A1.368,1.368,0,0,1,27.911,24.448Z",
    transform: "translate(-15.308 -14.017)",
    fill: "#0b420d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50196",
    "data-name": "Path 50196",
    d: "M15,24.439c1.981,0,2.173,2.173,3.042,2.173.7,0,.869-.869.869-.869a.6.6,0,0,1-.869,0c-.326-.326-.9-1.531-1.594-1.684A1.363,1.363,0,0,0,15,24.439Z",
    transform: "translate(-10.219 -14.009)",
    fill: "#0b420d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_469",
    "data-name": "Ellipse 469",
    cx: 1.827,
    cy: 2.088,
    rx: 1.827,
    ry: 2.088,
    transform: "translate(11.484 11.727)",
    fill: "#7cb342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50197",
    "data-name": "Path 50197",
    d: "M35.869,30a.869.869,0,0,0-.869.869h1.738A.869.869,0,0,0,35.869,30Z",
    transform: "translate(-21.527 -17.397)",
    fill: "#0b420d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_470",
    "data-name": "Ellipse 470",
    cx: 2.088,
    cy: 2.088,
    rx: 2.088,
    ry: 2.088,
    transform: "translate(2.088 11.727)",
    fill: "#7cb342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50198",
    "data-name": "Path 50198",
    d: "M9.869,30A.869.869,0,0,0,9,30.869h1.738A.869.869,0,0,0,9.869,30Z",
    transform: "translate(-6.827 -17.397)",
    fill: "#0b420d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50199",
    "data-name": "Path 50199",
    d: "M16.066,36.129l-2.8-1.4c-3.745-1.873-3.29-3.886-3.269-3.971l.843.211s-.244,1.453,2.815,2.983l2.413,1.207,2.413-1.206c3.059-1.53,2.815-2.979,2.813-2.993l.845-.2c.021.085.476,2.1-3.269,3.971Z",
    transform: "translate(-7.373 -17.825)",
    fill: "#0b420d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrinchHighlighted);
export default __webpack_public_path__ + "static/media/grinchHighlighted.296abd98283fdbae8d241a51b9a5cd3d.svg";
export { ForwardRef as ReactComponent };